import React from 'react';
import '../../style/chart_container.scss';
import '../../style/chart.scss';
import { getPercentPieChartConfig } from '../../getPieChartConfig';
import { ChartPercentLegend } from '../../legend/ChartLegend';
import { LazyReactChart } from '../../LazyReactChart';

type Props = {
  sizesData: Array<number> | undefined | null;
  sizesLabels: Array<string> | undefined | null;
};

export class CompanySizeTypologiesChart extends React.Component<Props> {
  sizesBaseH = 218;

  render() {
    const { sizesData, sizesLabels } = this.props;
    return (
      <div className="chart-container">
        <div className="chart">
          {sizesData && sizesLabels && (
            <LazyReactChart
              config={getPercentPieChartConfig({
                data: sizesData,
                labels: sizesLabels,
                baseH: this.sizesBaseH,
              })}
            />
          )}
        </div>
        {sizesData && sizesLabels && (
          <ChartPercentLegend
            data={sizesData}
            labels={sizesLabels}
            baseH={this.sizesBaseH}
          />
        )}
      </div>
    );
  }
}
